module.exports = __webpack_public_path__ + "img/caf887b.jpg";